import React from "react";
import { Button, CircularProgress, Backdrop } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { getSystemFormattedTimestamp } from "../../../utils/dateFormatted";
import { logger } from "../../../utils/logger";
import { useSelector } from "react-redux";

const SummaryDownloadButton = ({ data, type }) => {
  const [loading, setLoading] = React.useState(false);
  const { user } = useSelector((state) => state.auth);
  const BaseUrl = process.env.REACT_APP_BASE_URL;
  const handleDownload = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${BaseUrl}api/summary/download`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data, type }),
      });

      if (!response.ok) {
        let errorMsg = "Failed to generate PDF";
        try {
          const errorData = await response.json();
          errorMsg = errorData.message || errorMsg;
        } catch {}
        throw new Error(errorMsg);
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${type} ${getSystemFormattedTimestamp()}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      logger.info("Summary Report PDF Downloaded Successfully", {
        username: user?.username,
        role: user?.role,
        filterType: type,
        rowsCount: data?.report?.length || 0,
      });
    } catch (err) {
      logger.error("Error downloading Summary Report PDF", {
        username: user?.username,
        role: user?.role,
        filterType: type,
        rowsCount: data?.report?.length || 0,
      });
      console.error("Error downloading PDF:", err);
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleDownload}>
        <PictureAsPdfIcon style={{ marginRight: 8 }} />
        Download
      </Button>
      <Backdrop open={loading} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
        <span style={{ marginLeft: 10 }}>Generating PDF, please wait...</span>
      </Backdrop>
    </>
  );
};

export default SummaryDownloadButton;
